import {css} from '@emotion/react'
import {Spin} from 'antd'

export default function FullPageSpinner() {
  return (
    <Spin spinning size="large">
      <div
        css={css`
          height: 100vh;
          display: flex;
          flex-direction: column;
          justify-content: 'center';
          align-items: 'center';
        `}
      ></div>
    </Spin>
  )
}
